import { Box, Typography, TextField, FormControlLabel, Switch } from '@mui/material';

export function MessageNodeFields({ localNodeData, updateNodeData }) {
  const AdvanceResponse = localNodeData.AdvanceResponse || false;

  return (
    <>
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Contenido del Mensaje
        </Typography>
        <TextField
          value={localNodeData.bodyText || ''}
          size="small"
          fullWidth
          multiline
          minRows={3}
          // permite que el usuario cambie el alto del área de texto
          sx={{
            '& .MuiInputBase-root': {
              alignItems: 'flex-start',
            },
            '& textarea': {
              resize: 'vertical', // usuario puede agrandar/achicar verticalmente
              overflow: 'auto',
            },
          }}
          onChange={(e) => updateNodeData('bodyText', e.target.value)}
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Respuesta esperada
          </Typography>
          <FormControlLabel
            sx={{ m: 0 }}
            control={
              <Switch
                size="small"
                checked={AdvanceResponse}
                onChange={(e) => updateNodeData('AdvanceResponse', e.target.checked)}
              />
            }
            label="Almacenar respuesta"
          />
        </Box>

        {/* MODO SIMPLE: mismo comportamiento anterior */}
        {!AdvanceResponse && (
          <TextField
            value={localNodeData.expected || ''}
            size="small"
            fullWidth
            multiline
            rows={2}
            onChange={(e) => updateNodeData('expected', e.target.value)}
          />
        )}

        {/* MODO AVANZADO: separar en output_key y valor esperado */}
        {AdvanceResponse && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField
              label="output_key"
              placeholder="Ej: respuesta_usuario"
              value={localNodeData.OutputKey || ''}
              size="small"
              fullWidth
              onChange={(e) => updateNodeData('OutputKey', e.target.value)}
            />
            <TextField
              label="Formato / valor esperado"
              placeholder="Ej: número de teléfono, correo electrónico, etc."
              value={localNodeData.expected || ''}
              size="small"
              fullWidth
              multiline
              rows={2}
              onChange={(e) => updateNodeData('expected', e.target.value)}
            />
          </Box>
        )}
      </Box>
    </>
  );
}